import { Navigate } from "react-big-calendar";
import PropTypes from "prop-types";

import { Default, Mobile } from "../../../components/Devices";
import CardEventsList from "./CardEventsList";
import MobileCardEventsList from "./MobileCardEventsList";
import { filteredCourses } from "../../../helpers/event";
import { useClassFilters } from "./ClassFilterProvider";

const CalendarDayView = ({
	components: {
		coursesByDate
	},
	date,
	localizer: { format }
}) => {
	const { filters } = useClassFilters();
	const dateString = format(date, "yyyy-MM-dd");

	return (
		<>
			<Default>
				<CardEventsList
					events={filteredCourses(coursesByDate[dateString] || [], filters)}
				/>
			</Default>
			<Mobile>
				<MobileCardEventsList
					events={filteredCourses(coursesByDate[dateString] || [], filters)}
				/>
			</Mobile>
		</>
	);
};

CalendarDayView.propTypes = {
	components: PropTypes.shape({
		coursesByDate: PropTypes.shape({}),
		filters: PropTypes.shape({}),
		setRegisteredCourses: PropTypes.func
	}),
	date: PropTypes.instanceOf(Date).isRequired,
	localizer: PropTypes.shape({
		format: PropTypes.func
	}).isRequired
};

CalendarDayView.defaultProps = {
	components: {}
};

CalendarDayView.navigate = (date, action, { localizer }) => {
	switch (action) {
	case Navigate.PREVIOUS:
		return localizer.add(date, -3, "day");

	case Navigate.NEXT:
		return localizer.add(date, 3, "day");

	default:
		return date;
	}
};

CalendarDayView.title = () => "Day View";

export default CalendarDayView;
